export const getConfirmedOrders = (orders) => {
    const newOrders = orders.filter(order => order.status === "PAGO");
    return newOrders;
}

export const getConfirmedOrdersQty = (orders) => {
    const newOrders = getConfirmedOrders(orders);
    return newOrders.length;
}